import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import React from 'react';
import trns from './trns';
import { DrugCardVariant } from './types';
import Button from '../design-system/ButtonTertiary';
import BellIcon from '../../icons/Bell';

const NotInStockLabel = ({
  setIsNotificationModalVisible,
  wrapperClassName = '',
  variant,
  isLabelVisible = true
}: {
  setIsNotificationModalVisible: (isVisible: boolean) => void;
  wrapperClassName?: string;
  variant?: DrugCardVariant;
  isLabelVisible?: boolean;
}) => {
  return (
    <div className={wrapperClassName}>
      {isLabelVisible && (
        <p className="lowercase text-shuttleGray fs-caption-reg">
          <FormattedMessage {...trns.notInStock} />
        </p>
      )}

      <div
        className={cn(
          'flex justify-between',
          variant === DrugCardVariant.FastSearchCard
            ? 'sm:pt-[19px]'
            : 'pt-[10px]'
        )}
      >
        <Button
          onClick={() => setIsNotificationModalVisible(true)}
          buttonLabel={<FormattedMessage {...trns.notifyAvailable} />}
          icon={{
            alt: 'arrow',
            size: { width: 16, height: 20 },
            component: BellIcon
          }}
        />
      </div>
    </div>
  );
};

export default NotInStockLabel;
